import { useTranslation } from 'react-i18next';
import { Heading } from 'components/Typography';
import { ContactInfoContext, withContactInfoMachineState } from 'domains/signup/contactInfo/data/ContactInfoContext';
import { LearningCenterFooter } from 'domains/signup/Components/LearningCenterFooter';
import { TherapyTarget } from 'domains/signup/data/types';

type Props = { state: string; target: TherapyTarget };

const StateNotSupported: React.FC<Props> = ({ target }) => {
  const { t } = useTranslation();

  return (
    <>
      <Heading level="h2" className="mb-16">
        {t('signup.steps.stateNotSupported.title')}
      </Heading>
      <Heading level="h7">{t('signup.steps.stateNotSupported.subtitle')}</Heading>

      <hr className="my-64 sm-d:my-40 mb-64 sm-d:mb-40 border-black-200" />

      <LearningCenterFooter variant={target === 'child' ? 'children' : 'adult'} />
    </>
  );
};

const ContactInfoWrapper = () => {
  const target = ContactInfoContext.useSelector(({ context }) => context.target);
  const state = ContactInfoContext.useSelector(({ context }) => context.state);

  return <StateNotSupported state={state as string} target={target as TherapyTarget} />;
};

export const ContactInfoStateNotSupported = withContactInfoMachineState(ContactInfoWrapper, 'stateNotSupported');
